<button
  class="upload-button"
  (click)="openUppyDashboard()"
  [attr.aria-label]="'uppy.addMedia' | transloco"
>
  <svg-icon class="upload-icon" fontSize="2em" [key]="'plus'"></svg-icon>
</button>

<bulb-uppy-dashboard #uppyDashboard
                     [folderId]="folderId"
                     [multiSelect]="false"
                     (uppyEventEmitter)="handleUppyEvents($event)">
</bulb-uppy-dashboard>
